import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Stack,
  Paper
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
 
const TOTAL_STEPS = 8;

const Step4GenderSelection = ({ onBack, onNext, selectedGender, setSelectedGender, currentStep = 4, showHeader = true, className }) => {
  const handleSelect = (gender) => {
    setSelectedGender(gender);
    onNext();
  };

  const renderSegmentedProgressBar = () => {
    return (
      <Box display="flex" gap={1} mb={1}>
        {Array.from({ length: TOTAL_STEPS }).map((_, index) => (
          <Box
            key={index}
            flex={1}
            height={4}
            borderRadius={5}
            sx={{
              backgroundColor: index < currentStep ? '#0D99FF' : '#e0e0e0',
              transition: 'background-color 0.3s ease',
            }}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box display="flex" alignItems="start" justifyContent="center" className={className} sx={{ paddingTop: { xs: 0, sm: 13, md: 6, }, paddingBottom: { xs: 0, sm: 3, md: 6, },}}>
      <Paper elevation={3} sx={{ p: { xs: '20px 15px', sm: 4, }, maxWidth: 480, width: '100%', borderRadius: { xs: '0', sm: '8px', md: '8px', boxShadow: 'none', }, position: 'relative', }}>
       {showHeader && (
       <> 
        {/* Multi-Segment Progress Bar */}
        {renderSegmentedProgressBar()}

        {/* Back Arrow */}
        <IconButton onClick={onBack}>
          <ArrowBackIosNewIcon />
        </IconButton>
         
        </>
        )}
        {/* Heading */}
        <Typography
          variant="h5"
          fontWeight={600}
          mb={1.5}
          align="center"
          fontFamily="ivypresto-headline, serif"
        >
          What is your gender?
        </Typography>

        {/* Gender Buttons */}
        <Stack spacing={2}>
          {['Male', 'Female', 'Non-binary/Other'].map((gender) => (
            <Button
              key={gender}
              variant={selectedGender === gender ? 'contained' : 'outlined'}
              onClick={() => handleSelect(gender)}
              fullWidth
              sx={{
                py: 1,
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                maxWidth: '200px',
                margin: '8px auto !important',
                border: selectedGender === gender ? '1px solid #2B1E1A' : '1px solid #CFD9DE',
                backgroundColor: selectedGender === gender ? '#2B1E1A' : 'transparent',
                color: selectedGender === gender ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: selectedGender === gender ? '#2B1E1A' : '#f5f5f5',
                },
              }}
            >
              {gender}
            </Button>
          ))}
        </Stack>
      </Paper>
    </Box>
  );
};

export default Step4GenderSelection;
